module.exports = __webpack_public_path__ + "static/media/share_icon_fff_132.c5ed5a01.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/old/share_icon_fff_132.png
// module id = 588
// module chunks = 0